import type { FaireAdPerformancePeriodEntity } from "../../entity_types/adPerformancePeriod";

export const perfP3HighBudgetNew202605: FaireAdPerformancePeriodEntity = {
  token: "perf_p3_high_budget_new_202605",
  type: "adPerformancePeriod",
  scope: "NEW_MARKETPLACE",
  periodType: "RECEIPT",
  startDate: "2026-05-01",
  endDate: "2026-05-31",
  impressions: 11991,
  clicks: 216,
  adsSpendDollars: 1254,
  budgetDollars: 1500,
  salesDollars: 12326,
  bestEstimateRoas: 9.83,
  bestEstimateType: "ACTUALIZED",
  budgetUtilization: 0.84,
  newCustomersAcquired: 7,
  dataAvailableAtDate: "2026-06-04",
  meta: {
    source: "mock",
    importedAt: "2026-07-06T00:00:00.000Z",
    importedBy: "advertiser-profiles",
  },
};
